(function () {
  if (window.__allerasNlPopupBound) return;
  window.__allerasNlPopupBound = true;

  var STORAGE_KEY = 'alleras-newsletter-popup';
  var COOKIE_NAME = 'alleras_nl_popup';
  var SESSION_KEY = 'alleras-nl-popup-dismissed';
  var showTimer = null;
  var dismissedThisPage = false;
  var ignoreSelectUntil = 0;
  var isDesignMode = window.Shopify && window.Shopify.designMode;

  function getPopup() {
    return document.querySelector('[data-alleras-nl-popup]');
  }

  function getExpiryDays() {
    var popup = getPopup();
    return popup ? Number(popup.getAttribute('data-expiry-days')) || 30 : 30;
  }

  function getDelay() {
    var popup = getPopup();
    return popup ? Number(popup.getAttribute('data-delay')) || 5 : 5;
  }

  function withinExpiry(timestamp) {
    if (!timestamp) return false;
    var maxAge = getExpiryDays() * 24 * 60 * 60 * 1000;
    return Date.now() - Number(timestamp) < maxAge;
  }

  function readCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return null;
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return { dismissedAt: Date.now() };
    }
  }

  function writeCookie(data) {
    var maxAge = getExpiryDays() * 24 * 60 * 60;
    var value = encodeURIComponent(JSON.stringify(data));
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE_NAME + '=' + value + '; path=/; max-age=' + maxAge + '; SameSite=Lax' + secure;
  }

  function readSessionDismissedAt() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return 0;
      return Number(raw) || 0;
    } catch (e) {
      return 0;
    }
  }

  function writeSessionDismissedAt(at) {
    try {
      sessionStorage.setItem(SESSION_KEY, String(at));
    } catch (e) {}
  }

  function readState() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return JSON.parse(stored);
    } catch (e) {}
    return readCookie();
  }

  function writeState(patch) {
    var data = Object.assign({}, readState() || {}, patch);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
    writeCookie(data);
    if (data.dismissedAt) writeSessionDismissedAt(data.dismissedAt);
  }

  function isSuppressed() {
    if (dismissedThisPage) return true;
    if (withinExpiry(readSessionDismissedAt())) return true;
    var state = readState();
    if (!state) return false;
    if (state.subscribed) return true;
    return withinExpiry(state.dismissedAt);
  }

  function isShown(el) {
    return !!(el && !el.hasAttribute('hidden'));
  }

  function canOpenDespiteSuppression(popup) {
    if (dismissedThisPage) return false;
    return (
      popup.hasAttribute('data-open-on-load') ||
      isShown(popup.querySelector('.alleras-nl-popup__success')) ||
      isShown(popup.querySelector('.alleras-nl-popup__error'))
    );
  }

  function shouldAutoOpen(popup) {
    if (dismissedThisPage) return false;
    if (canOpenDespiteSuppression(popup)) return true;
    if (isSuppressed()) return false;
    if (document.body.classList.contains('template-password')) return false;
    if (document.body.classList.contains('template-cart')) return false;
    return true;
  }

  function openPopup(force) {
    var popup = getPopup();
    if (!popup) return;
    if (!force && !shouldAutoOpen(popup)) return;

    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('alleras-nl-popup-open');
    var input = popup.querySelector('.alleras-nl-popup__input');
    if (input) {
      window.setTimeout(function () {
        input.focus();
      }, 50);
    }
  }

  function closePopup(persist) {
    var popup = getPopup();
    if (!popup) return;

    dismissedThisPage = true;
    ignoreSelectUntil = Date.now() + 1000;
    clearTimeout(showTimer);
    showTimer = null;
    popup.setAttribute('hidden', '');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('alleras-nl-popup-open');
    if (persist) {
      writeState({ dismissedAt: Date.now() });
    }
  }

  function scheduleOpen() {
    var popup = getPopup();
    if (!popup) return;

    clearTimeout(showTimer);
    if (!shouldAutoOpen(popup)) return;

    if (canOpenDespiteSuppression(popup)) {
      openPopup();
      return;
    }

    var delayMs = (isDesignMode ? 0 : getDelay()) * 1000;
    showTimer = window.setTimeout(function () {
      if (dismissedThisPage) return;
      openPopup();
    }, delayMs);
  }

  function init() {
    var popup = getPopup();
    if (!popup) return;

    if (dismissedThisPage || (isSuppressed() && !canOpenDespiteSuppression(popup))) {
      closePopup(false);
      return;
    }

    scheduleOpen();
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.nodeType !== 1) target = target.parentElement;
      if (!(target && target.closest && target.closest('[data-alleras-nl-close]'))) return;
      event.preventDefault();
      event.stopPropagation();
      closePopup(true);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var popup = getPopup();
    if (event.key === 'Escape' && popup && !popup.hidden) {
      closePopup(true);
    }
  });

  document.addEventListener('alleras:newsletter-subscribed', function () {
    writeState({ subscribed: true, at: Date.now(), dismissedAt: Date.now() });
  });

  window.addEventListener('pageshow', init);

  if (isDesignMode) {
    document.addEventListener('shopify:section:select', function (event) {
      if (Date.now() < ignoreSelectUntil) return;
      var sectionId = event.detail && event.detail.sectionId;
      if (!sectionId) return;
      var section = document.getElementById('shopify-section-' + sectionId);
      if (section && section.querySelector('[data-alleras-nl-popup]')) {
        openPopup(true);
      }
    });

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target instanceof HTMLElement && event.target.querySelector('[data-alleras-nl-popup]')) {
        init();
      }
    });
  }
})();
